import { Link } from "react-router-dom";
import Header from "../components/Header";
import HomeHero from "../components/heroes/HomeHero";
// import HeroForm from '../components/HeroForm';
import ServiceHighlights from "../components/ServiceHighlights";
// import ServicesOverview from '../components/ServicesOverview';
// import InterestSection from '../components/InterestSection';
import SmartHomeSection from "../components/SmartHomeSection";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
import { Phone } from "lucide-react";

function Home() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektricien nodig? Direct bereikbaar - Elektraaanleggen.nl"
        description="Op zoek naar een ervaren elektricien? Elektraaanleggen.nl is direct bereikbaar voor alle elektra werkzaamheden. Betrouwbaar, snel en vakkundig in heel Nederland!"
        schema={generateServiceSchema({
          name: "Elektricien van Elektraaanleggen.nl",
          description:
            "Direct een betrouwbare elektricien nodig? Wij bieden snelle en vakkundige elektra werkzaamheden door gecertificeerde professionals, overal in Nederland. Neem direct contact op voor een afspraak!",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />
      <HomeHero />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wij zijn uw betrouwbare elektriciensbedrijf
            </h2>

            <p className="mb-4">
              Wij van <strong>Elektra Aanleggen</strong> zijn uw professionele
              elektriciensbedrijf, wij staan klaar om u te helpen met al uw
              elektrische installaties. Of het nu gaat om een groepenkast
              vervangen, een extra stopcontact plaatsen of een volledige
              installatie, wij leveren vakmanschap voor een eerlijke prijs. Bij
              ons weet u altijd vooraf wat u betaalt – wij geven van tevoren een
              vaste prijs, zonder verrassingen achteraf.
            </p>

            <p className="mb-4">
              Als zegelgerechtigde en geregistreerde elektriciens garanderen wij
              een veilige en vakkundige installatie, altijd volgens de nieuwste
              normen en mét keurmerk. Heeft u met spoed een elektricien nodig?
              Wij zijn direct beschikbaar!
            </p>

            <p className="mb-4">
              Kies voor een betrouwbaar elektriciensbedrijf dat staat voor
              kwaliteit, service en vakmanschap.
            </p>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/elektricien-12.jpg"
              />
            </div>
          </div>
        </div>
      </section>
      <ServiceHighlights />

      <SmartHomeSection />
      <FAQ />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Home;
